export enum LogLevel {
  info = 'info',
  success = 'success',
  warning = 'warning',
  error = 'error',
}
